module.exports = __webpack_public_path__ + "b211de32ceb17d8ccdb2fc71c8d27f99.svg";